export const ANALYTICS_PAGE = 'analyticsPage';
export const CONTACTS_PAGE = 'contactsPage';
export const BILLING_PAGE = 'billingPage';
export const INVOICE_PAYMENTS = 'invoicepayments';
export const USER_MANAGEMENT_PAGE = 'userManagementPage';
export const PDP_PAYMENTS = 'pdpPayments';
export const PDP_APPLICATIONS = 'pdpApplications';
export const PROXY_PATH = 'rental-manager/proxy/';
export const FILE_PROXY_PATH = 'rental-manager/file-proxy/';
export const RENTAL_GROWTH_PROXY_PATH = 'rental-manager/growth/growth-proxy/';
export const RENTAL_GROWTH_API_V1_PREFIX = 'rental-growth-api/api/v1';
export const RENTAL_MANAGER_API_V1_PREFIX = 'rental-manager-api/api/v1';
export const RENTAL_MANAGER_API_V2_PREFIX = 'rental-manager-api/api/v2';
export const SETTINGS_PAGE = 'rental-manager-api/settings';
